import React, { useState, useRef, useEffect } from "react";
import { Link } from "react-router-dom";
import { Menu, X, Phone, ChevronDown } from "lucide-react";

const Header: React.FC = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [isFacilitiesOpen, setIsFacilitiesOpen] = useState(false);
  const dropdownRef = useRef<HTMLDivElement>(null);

  const navigation = [
    { name: "Home", href: "/" },
    { name: "About", href: "/about" },
    {
      name: "Facilities",
      href: "/facilities",
      hasDropdown: true,
    },
    { name: "Services", href: "/services" },
    { name: "Contact", href: "/contact" },
  ];

  // Close dropdown when clicking outside
  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (
        dropdownRef.current &&
        !dropdownRef.current.contains(event.target as Node)
      ) {
        setIsFacilitiesOpen(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  const isActive = (href: string) => location.pathname === href;

  // For mobile, we'll use a simple approach
  const [isMobileFacilitiesOpen, setIsMobileFacilitiesOpen] = useState(false);

  if (
    location.pathname.startsWith("/dashboard") &&
    !location.pathname.startsWith("/dashboard/login")
  ) {
    return <header></header>;
  } else {
    return (
      <header className="bg-white shadow-lg sticky top-0 z-50">
        <div className="container mx-auto px-4">
          <div className="flex justify-between items-center py-4">
            {/* Logo */}
            <Link to="/" className="flex items-center space-x-2">
              <img src="/transparent-logo.jpg" className="h-18 w-24" />
            </Link>

            {/* Desktop Navigation */}
            <nav className="hidden lg:flex items-center space-x-8">
              {navigation.map((item) => (
                <div
                  key={item.name}
                  className="relative"
                  ref={item.hasDropdown ? dropdownRef : null}
                >
                  {item.hasDropdown ? (
                    <>
                      <button
                        onClick={() => setIsFacilitiesOpen(!isFacilitiesOpen)}
                        className={`flex items-center font-medium transition-colors duration-200 hover:text-primary-green ${location.pathname.startsWith("/facilities")
                          ? "text-primary-green"
                          : "text-gray-700"
                          }`}
                      >
                        {item.name}
                        <ChevronDown
                          className={`ml-1 h-4 w-4 transition-transform duration-200 ${isFacilitiesOpen ? "rotate-180" : ""
                            }`}
                        />
                      </button>

                      {/* Dropdown Menu */}
                      {/* {isFacilitiesOpen && (
                        <div className="absolute top-full left-0 mt-2 w-72 bg-white rounded-lg shadow-xl border border-gray-200 py-2 z-50">
                          <Link
                            to="/facilities"
                            onClick={() => setIsFacilitiesOpen(false)}
                            className="block px-4 py-2 text-gray-700 hover:bg-blue-50 hover:text-primary-green font-medium"
                          >
                            View All Facilities
                          </Link>
                          <div className="border-t border-gray-200 my-2"></div>
                          {Object.entries(facilitiesData).map(
                            ([id, facility]) => (
                              <Link
                                key={id}
                                to={`/facilities/${id}`}
                                onClick={() => setIsFacilitiesOpen(false)}
                                className="block px-4 py-3 hover:bg-blue-50 group"
                              >
                                <div className="font-medium text-gray-900 group-hover:text-primary-green">
                                  {facility.name}
                                </div>
                                <div className="text-xs text-gray-600 mt-1 truncate">
                                  {facility.location}
                                </div>
                              </Link>
                            )
                          )}
                        </div>
                      )} */}
                      {isFacilitiesOpen && (
                        <div className="absolute top-full left-0 mt-2 w-80 bg-white rounded-lg shadow-xl border border-gray-200 py-3 z-50">
                          <Link
                            to="/facilities"
                            onClick={() => setIsFacilitiesOpen(false)}
                            className="block px-4 py-3 text-primary-green font-semibold hover:bg-blue-50"
                          >
                            View All Facilities →
                          </Link>

                          {/*  <div className="grid grid-cols-1 gap-1 p-2">
                            {facilitiesData.map((facility) => (
                              <Link
                                key={facility.id}
                                to={`/facilities/${facility.id}`}
                                onClick={() => setIsFacilitiesOpen(false)}
                                className="flex items-center p-3 hover:bg-blue-50 rounded-lg group"
                              >
                                <Home className="h-5 w-5 text-gray-400 mr-3 group-hover:text-primary-green" />
                                <div className="flex-1">
                                  <div className="font-medium text-gray-900 group-hover:text-primary-green">
                                    {facility.shortname}
                                  </div>
                                  <div className="text-sm text-gray-600 flex items-center mt-1">
                                    <MapPin className="h-3 w-3 mr-1" />
                                    {facility.location.split(",")[0]}
                                  </div>
                                </div>
                                <div className="text-xs px-2 py-1 rounded bg-blue-100 text-primary-green">
                                  {facility.specialty.trim()}
                                </div>
                              </Link>
                              // <Link
                              //   key={id}
                              //   to={`/facilities/${id}`}
                              //   onClick={() => setIsFacilitiesOpen(false)}
                              //   className="flex items-center px-4 py-3 hover:bg-blue-50 group"
                              // >
                              //   <Home className="h-5 w-5 text-gray-400 mr-3 group-hover:text-primary-green" />
                              //   <div className="flex-1">
                              //     <div className="font-medium text-gray-900 group-hover:text-primary-green">
                              //       {facility.name}
                              //     </div>
                              //     <div className="text-sm text-gray-600 flex items-center mt-1">
                              //       <MapPin className="h-3 w-3 mr-1" />
                              //       {facility.location.split(",")[0]}
                              //     </div>
                              //   </div>
                              // </Link>
                            ))}
                          </div> */}
                        </div>
                      )}
                    </>
                  ) : (
                    <Link
                      to={item.href}
                      className={`font-medium transition-colors duration-200 hover:text-primary-green ${isActive(item.href)
                        ? "text-primary-green"
                        : "text-gray-700"
                        }`}
                    >
                      {item.name}
                    </Link>
                  )}
                </div>
              ))}
            </nav>

            {/* Desktop - Right Side (Phone & Auth) */}
            <div className="hidden lg:flex items-center space-x-6">
              <a
                href="tel:+17209997773"
                className="inline-flex items-center px-8 py-4 text-primary-green font-semibold rounded-lg hover:bg-primary-green hover:text-white transition-all duration-300 transform hover:scale-105"
              >
                <Phone className="mr-2 h-5 w-5" />
                (720) 999-7773
              </a>
            </div>

            {/* Mobile Menu Button */}
            <button
              onClick={() => setIsMenuOpen(!isMenuOpen)}
              className="lg:hidden p-2 rounded-md text-gray-700 hover:text-primary-green hover:bg-gray-100"
            >
              {isMenuOpen ? (
                <X className="h-6 w-6" />
              ) : (
                <Menu className="h-6 w-6" />
              )}
            </button>
          </div>

          {/* Mobile Navigation */}
          {isMenuOpen && (
            <div className="lg:hidden py-4 border-t border-gray-200">
              <nav className="flex flex-col space-y-1">
                {navigation.map((item) => (
                  <div key={item.name}>
                    {item.hasDropdown ? (
                      <>
                        <button
                          onClick={() =>
                            setIsMobileFacilitiesOpen(!isMobileFacilitiesOpen)
                          }
                          className={`flex justify-between items-center w-full px-3 py-2 rounded-md font-medium transition-colors duration-200 hover:bg-gray-100 hover:text-primary-green ${location.pathname.startsWith("/facilities")
                            ? "text-primary-green bg-blue-50"
                            : "text-gray-700"
                            }`}
                        >
                          <span>{item.name}</span>
                          <ChevronDown
                            className={`h-4 w-4 transition-transform duration-200 ${isMobileFacilitiesOpen ? "rotate-180" : ""
                              }`}
                          />
                        </button>

                        {/* Mobile Dropdown Items */}
                        {/* {isMobileFacilitiesOpen && (
                            <div className="ml-4 mt-1 space-y-1 border-l-2 border-blue-100 pl-4">
                              <Link
                                to="/facilities"
                                onClick={() => {
                                setIsMenuOpen(false);
                                setIsMobileFacilitiesOpen(false);
                              }}
                              className="block px-3 py-2 rounded-md text-gray-700 hover:bg-gray-100 hover:text-primary-green font-medium"
                            >
                              View All Facilities
                            </Link>

                            {Object.entries(facilitiesData).map(
                              ([id, facility]) => (
                                <Link
                                  key={id}
                                  to={`/facilities/${id}`}
                                  onClick={() => {
                                    setIsMenuOpen(false);
                                    setIsMobileFacilitiesOpen(false);
                                  }}
                                  className="block px-3 py-2 rounded-md text-gray-700 hover:bg-gray-100 hover:text-primary-green"
                                >
                                  <div className="font-medium">
                                    {facility.name}
                                  </div>
                                  <div className="text-sm text-gray-600 truncate">
                                    {facility.location}
                                  </div>
                                </Link>
                              )
                            )}
                          </div>
                        )} */}
                        {/* Simplified Mobile Dropdown */}
                        {isMobileFacilitiesOpen && (
                          <div className="ml-4 mt-1 space-y-1">
                            <div className="text-xs font-semibold text-gray-500 uppercase tracking-wider px-3 py-1">
                              Our Facilities
                            </div>
                            <Link
                              to="/facilities"
                              onClick={() => setIsFacilitiesOpen(false)}
                              className="block px-4 py-3 text-primary-green font-semibold hover:bg-blue-50"
                            >
                              View All Facilities →
                            </Link>
                            {/* {Object.entries(facilitiesData).map(
                              ([id, facility]) => (
                                <Link
                                  key={id}
                                  to={`/facilities/${id}`}
                                  onClick={() => {
                                    setIsMenuOpen(false);
                                    setIsMobileFacilitiesOpen(false);
                                  }}
                                  className="flex items-center px-3 py-2 rounded-md hover:bg-gray-100"
                                >
                                  <div className="w-2 h-2 rounded-full bg-primary-green mr-3"></div>
                                  <div>
                                    <div className="font-medium text-gray-900">
                                      {facility.name}
                                    </div>
                                    <div className="text-xs text-gray-600 truncate">
                                      {facility.location.split(",")[1]?.trim()}
                                    </div>
                                  </div>
                                </Link>
                              ),
                            )} */}
                          </div>
                        )}
                      </>
                    ) : (
                      <Link
                        to={item.href}
                        onClick={() => setIsMenuOpen(false)}
                        className={`px-3 py-2 rounded-md font-medium transition-colors duration-200 hover:bg-gray-100 hover:text-primary-green ${isActive(item.href)
                          ? "text-primary-green bg-blue-50"
                          : "text-gray-700"
                          }`}
                      >
                        {item.name}
                      </Link>
                    )}
                  </div>
                ))}

                {/* Mobile - Phone Number */}
                <div className="flex items-center space-x-2 px-3 py-2 text-primary-green border-t border-gray-200 mt-2">
                  <Phone className="h-5 w-5" />
                  <span className="font-semibold">(720) 999-7773</span>
                </div>
              </nav>
            </div>
          )}
        </div>
      </header>
    );
  }
};

export default Header;
